var _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPill2 = function SvgPill2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pill-2_svg__a",
    width: 17,
    height: 17,
    x: 17,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.99 4.941H34v15.503H17.99z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pill-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m24.25 20.444 6.624-3.824c2.983-1.722 4.014-5.57 2.293-8.553h-.001c-1.722-2.983-5.57-4.014-8.553-2.292L17.99 9.6z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m18.011 9.6-6.624-3.824c-2.982-1.723-6.831-.691-8.553 2.291s-.69 6.83 2.292 8.553l6.624 3.824z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M9.538 19.183a2.414 2.414 0 1 0 4.829.002 2.414 2.414 0 0 0-4.83-.002M19.542 24.426a2.415 2.415 0 1 0 4.83.001 2.415 2.415 0 0 0-4.83 0M14.286 29.67a2.415 2.415 0 1 0 4.83 0 2.415 2.415 0 0 0-4.83 0",
    clipRule: "evenodd"
  })));
};
export default SvgPill2;